<template>
  <div class="custom-keyboard-wrapper" :style="wrapperStyle">
    <!-- Keyboard menu -->
    <div class="custom-keyboard" v-show="isOpen">
      <div
          v-for="key in keys"
          :key="key"
          class="ck-button"
          @click="press(key)"
      >
        <div class="ck-button-inner">{{ key }}</div>
      </div>
    </div>

    <!-- Toggle (blijft altijd staan) -->
    <div class="custom-keyboard-toggler" @click="toggle">
        {{ isOpen ? closeLabel : openLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomKeyboard',
  props: {
    value: { type: Boolean, default: false }, // v-model open/dicht
    keys: {
      type: Array,
      default: () => ["'", 'é', 'ë', 'ï', 'ö', 'ü']
    },
    openLabel: { type: String, default: 'abc' },
    closeLabel: { type: String, default: 'X' },

    // Positionering van de wrapper (absolute) – jij zet ‘m waar je wilt
    left: { type: [String, Number], default: null },
    right: { type: [String, Number], default: null },
    top: { type: [String, Number], default: null },
    bottom: { type: [String, Number], default: null },
    zIndex: { type: [String, Number], default: 999999 }
  },
  data() {
    return {
      isOpen: this.value
    }
  },
  watch: {
    value(val) {
      this.isOpen = val
    },
    isOpen(val) {
      this.$emit('input', val)     // v-model
      this.$emit('toggle', val)    // extra emit
      this.$emit(val ? 'open' : 'close')
    }
  },
  computed: {
    wrapperStyle() {
      const toCss = (v) => (v === null || v === undefined) ? null : (typeof v === 'number' ? `${v}px` : v)
      const style = {
        left: toCss(this.left),
        right: toCss(this.right),
        top: toCss(this.top),
        bottom: toCss(this.bottom),
        zIndex: this.zIndex
      }
      // verwijder nulls
      Object.keys(style).forEach(k => style[k] == null && delete style[k])
      return style
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
      this.$nextTick(() => {
        this.$emit('focus-input')
      })
    },
    press(char) {
      this.$emit('press', char) // jouw parent kan dit in input plakken
      this.$nextTick(() => {
        this.$emit('focus-input')
      })
    }
  }
}
</script>

<style scoped>
/* Wrapper: absoluut positioneerbaar via props (left/right/top/bottom) */
.custom-keyboard-wrapper{
  position: absolute;          /* jij zet 'm ergens neer */
  right: -20px;                     /* pas aan */
  bottom: 0;                   /* pas aan */
  z-index: 999999;
}

/* Toggle knop: linksonder in wrapper */
.custom-keyboard-toggler{
  position: absolute;
  left: 0;
  bottom: 0;

  width: 75px;
  height: 75px;

  background: #fff;
  border: 2px solid #DBD7C2;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
}

/* Keyboard menu: erboven */
.custom-keyboard{
  position: absolute;
  left: 0;
  bottom: calc(75px + 10px);

  width: 196px;
  height: 282px;

  background: #fff;
  border: 2px solid #DBD7C2;
  border-radius: 10px;

  padding: 16px;
  box-sizing: border-box;

  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

/* Keys (menu) */
.custom-keyboard .ck-button{
  width: 74px;
  height: 74px;

  background-color: #31694B;
  border-radius: 4px;

  position: relative;
}

.custom-keyboard .ck-button-inner{
  position: absolute;
  inset: 4px;

  background-color: #3CAE2A;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
  font-size: 40px;
  line-height: 1;
}

/* Toggle (kleine key look) */
.custom-keyboard-toggler .ck-button{
  width: 46px;
  height: 46px;

  background-color: #31694B;
  border-radius: 2px;

  position: relative;
}

.custom-keyboard-toggler .ck-button-inner{
  position: absolute;
  inset: 2px;

  background-color: #3CAE2A;
  border-radius: 2px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
  font-size: 19px;
  line-height: 1;
}
</style>
